import { useContext } from 'react'
import { UserContext } from '../../../base/components/base-container/BaseContainer'
import { ROLES } from '../../../global/constants/users'
import styles from './styles.module.css'

interface LocationAddEditButtonsHolderProps {
  onOpenLocationModal: Function
  selectedLocationObjectId?: string
}

export default function LocationAddEditButtonsHolder({
  onOpenLocationModal,
  selectedLocationObjectId,
}: LocationAddEditButtonsHolderProps) {
  const { user } = useContext(UserContext)
  const { locations } = user || {}

  const chosenLocation = locations?.find(
    (location) => location.objectId === selectedLocationObjectId,
  )
  const canSeeEditButton =
    [
      ROLES.STORE_REPRESENTATIVE,
      ROLES.STORE_MANAGER,
      ROLES.ADMIN,
      ROLES.SUPER_ADMIN,
      ROLES.REGIONAL_MANAGER,
      ROLES.CALL_CENTER_REPRESENTATIVE,
    ].includes(user?.role || '') && chosenLocation?.name
  const canSeeAddButton = [ROLES.ADMIN, ROLES.SUPER_ADMIN].includes(
    user?.role || '',
  )
  const editOrViewButton = [
    ROLES.REGIONAL_MANAGER,
    ROLES.CALL_CENTER_REPRESENTATIVE,
  ]
    ? 'View'
    : 'Edit'
  return (
    <div className={styles.locationButtonsHolder}>
      <button
        className={`${styles.locationAddButton} ${styles.locationButton}`}
        onClick={() => onOpenLocationModal()}
        style={{ display: canSeeAddButton ? 'flex' : 'none' }}
      >
        Create Location
      </button>
      <button
        className={`${styles.locationEditButton} ${styles.locationButton}`}
        onClick={() => onOpenLocationModal(selectedLocationObjectId)}
        style={{ display: canSeeEditButton ? 'flex' : 'none' }}
      >
        {editOrViewButton} {chosenLocation?.name || 'Location'}
      </button>
    </div>
  )
}
